/**
 * Animation constants for consistent timing and easing across components
 */

/**
 * Lerp (linear interpolation) factors for smooth animations
 * Higher values = faster/snappier, lower values = slower/smoother
 */
export const LERP_FACTOR = {
  /** Very slow organic drift (0.05) */
  drift: 0.05,
  /** Slow smooth scaling (0.08) */
  scale: 0.08,
  /** Smooth responsive cursor following (0.12) */
  cursor: 0.12,
  /** Snappy position updates (0.15) */
  position: 0.15,
} as const;

/**
 * Animation durations in milliseconds
 */
export const ANIMATION_DURATION = {
  /** Fast interactions (200ms) */
  fast: 200,
  /** Normal transitions (300ms) */
  normal: 300,
  /** Slow animations (500ms) */
  slow: 500,
} as const;
